// Module generated from Markdown by Markdown Component Loader v1.1.0
import React from 'react';
import PropTypes from 'prop-types';

MarkdownComponent.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  elementProps: PropTypes.object
};

MarkdownComponent.defaultProps = {
  elementProps: {}
};

MarkdownComponent['title'] = 'Docker';

function MarkdownComponent(props) {
  const { className, style, elementProps } = props;

  return (
    <div className={className} style={style}>
      <p {...elementProps['p']}>Start an agent with the <a href="https://hub.docker.com/r/buildkite/agent/" {...elementProps['a']}>official image</a> based on Alpine Linux:</p>
      <pre {...elementProps['pre']}><code className="language-bash" {...elementProps['code']}>docker run -e BUILDKITE_AGENT_TOKEN=<span className="hljs-string" {...elementProps['span']}>"{ props.token || 'INSERT-YOUR-AGENT-TOKEN-HERE' }"</span> buildkite/agent<br {...elementProps['br']} /></code></pre>
      <p {...elementProps['p']}>A much larger Ubuntu-based image is also available:</p>
      <pre {...elementProps['pre']}><code className="language-bash" {...elementProps['code']}>docker run -e BUILDKITE_AGENT_TOKEN=<span className="hljs-string" {...elementProps['span']}>"{ props.token || 'INSERT-YOUR-AGENT-TOKEN-HERE' }"</span> buildkite/agent:ubuntu<br {...elementProps['br']} /></code></pre>
      <p className="rounded bg-silver p2" {...elementProps['p']}>Alternatively all our installers are capable of running your builds within isolated Docker containers. Simply install the relevant agent for your system and see our <a href="/docs/agent/docker" {...elementProps['a']}>Docker docs</a> for more details.</p>
    </div>
  );
};

export default MarkdownComponent;
